import useExperimentBucket from './useExperimentBucket';

const useIsInBucket = (experimentId: string, bucketId: string, otherBuckets: string[] = []) => {
  const assignedBucket = useExperimentBucket(experimentId, [bucketId, ...otherBuckets]);

  return assignedBucket === null ? null : bucketId === assignedBucket;
};

export default useIsInBucket;
